import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Table, useDrawer } from "@digital-services/ui";
import type { SortQueryDirection } from "@ds-cps/ui";

import { AuditLogModel } from "@audit-log/models";

import { LogDetailsDrawerContent } from "../drawer/LogDetailsDrawerContent";
import { AuditLogHeader } from "./AuditLogHeader";
import { AuditLogRow } from "./AuditLogRow";

interface Props {
  auditLog: AuditLogModel[];
  activeSort: string;
  sortDirection: SortQueryDirection | undefined;
  handleSort: (sortName: string) => void;
}

export const AuditLogTable: FC<Props> = props => {
  const { showDrawer } = useDrawer();

  const { auditLog, activeSort, sortDirection, handleSort } = props;

  function handleSortHeaderClick(columnName: string) {
    handleSort(columnName);
  }

  const { t: tAuditLog } = useTranslation(undefined, {
    keyPrefix: "audit-log"
  });

  return (
    <Table className="w-full" rowHoverHighlight>
      <thead className="[&>tr>th]:sticky [&>tr>th]:top-0 [&>tr>th]:bg-white">
        <AuditLogHeader
          handleSortHeaderClick={handleSortHeaderClick}
          activeSort={activeSort}
          sortDirection={sortDirection}
        />
      </thead>
      <tbody data-testid="tbody">
        {auditLog.map((logRecord: AuditLogModel) => (
          <AuditLogRow
            key={`key-${logRecord.id}-${logRecord.action}`}
            data={logRecord}
            onRowClick={() => {
              showDrawer({
                title: tAuditLog("drawer.title"),
                children: <LogDetailsDrawerContent data={logRecord} />
              });
            }}
          />
        ))}
      </tbody>
    </Table>
  );
};
